"use client";
import styles from "./ProductSizeAndFitSideDrawer.module.scss";
import { Attribute } from "@/types/prodcatBaseTypes";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type Props = {
  attributes: Attribute[];
  productType: string;
};

export function ProductSizeAndFitSideDrawerUI({
  attributes,
  productType,
}: Props) {
  const [open, setOpen] = useState(false);
  if (productType === "RetiredStaticBundle") return null;
  if (attributes.length === 0) return null;

  return (
    <>
      <ListItem
        label="Size and fit"
        onClick={withSideDrawerAnalytics("Size and Fit", () => setOpen(true))}
        trailingIcon={<ArrowRight size="medium" />}
        data-testid="drawer:size-and-fit"
      />
      <Drawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Size and fit"
        primaryButtonText="Close"
      >
        <dl
          data-testid="product:size-and-fit:list"
          className={styles.productSizeAndFitList}
        >
          {attributes.map((attr) => (
            <div key={attr.key} className={styles.listItem}>
              <dt
                data-testid="product:size-and-fit:list:label"
                className={styles.listTitle}
              >
                {attr.displayName || attr.key} -{" "}
              </dt>
              <dd
                data-testid="product:size-and-fit:list:value"
                className={styles.listDesc}
              >
                {attr.values}
              </dd>
            </div>
          ))}
        </dl>
      </Drawer>
    </>
  );
}
